import { render, staticRenderFns } from "./BatchTicketOrder.vue?vue&type=template&id=6a235c78&scoped=true&"
import script from "./BatchTicketOrder.vue?vue&type=script&lang=js&"
export * from "./BatchTicketOrder.vue?vue&type=script&lang=js&"
import style0 from "./BatchTicketOrder.vue?vue&type=style&index=0&id=6a235c78&lang=less&scoped=true&"
import style1 from "./BatchTicketOrder.vue?vue&type=style&index=1&lang=less&"
import style2 from "./BatchTicketOrder.vue?vue&type=style&index=2&id=6a235c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a235c78",
  null
  
)

export default component.exports